export const toggleAccordian = (accordianName) => ({
    type: accordianName
})

export const savePersonalInfo = (data) => ({
    type: "SAVE_PERSONAL_INFO",
    data: data
})

export const saveCreditCheckInfo = (data) => ({
    type: "SAVE_CREDIT_CHECK_INFO",
    data: data
})

export const autoPayPaymentMethodSave = (data) => ({
    type: "SAVE_AUTOPAY_PAYMENT_METHOD",
    data
});
export const autoPayResponse = (data) => ({
    type: "AUTOPAY_PAYMENT_METHOD_RESPONSE",
    data
});
export const enrollPFB = (data) => ({
    type: "ENROLL_PFB",
    data
});

export const updateInstallmentsInfo = (data) => ({
    type: "UPDATE_INSTALLMENTS_INFO",
    data
});

export const updateCCInfo = (data) => ({
    type: "UPDATE_CC_INFO",
    data
});

export const updateTosInfo = (data) => ({
    type: "UPDATE_TOS_INFO",
    data
});

export const generateSIInfo =(data) =>({
    type: "UPDATE_SI_INFO",
    data
});

export const saveBusinessInfo =(data) =>({
    type: "SAVE_BUSINESS_INFO",
    data
});


export const setCovidqns =(data)=>({
    type:"UPDATE_COVID_INFO",
    data
}); 

export const selectedDueDate =(data)=>({
    type:"SELECTED_DUE_DATE",
    data
}); 

export const submitOrder = (data) => ({
    type: "SUBMIT_ORDER",
    data
});

export const reserveDueDate =(data) => ({
    type: "RESERVER_DUE_DATE",
    data
});

export const autoPayLog = (data) => ({
    type: "AUTOPAY_LOG",
    data
});

export const checkout = (data) => ({
    type: "CHECKOUT",
    data: data
});

export const doBusinessInfoValidation = (data) => ({
    type: "DO_BUSINESS_VALIDATION",
    data 
});
export const setNewAddressFlow = (data) => ({
    type: 'SET_NEW_ADDRESS_FLOW',
    data
});

export const creditCheck = (data) => ({
    type: 'CREDIT_CHECK',
    data
});

export const doInstallmentValidation = (data) => ({
    type: 'DO_INSTALLMENT_VALIDATION',
    data
});

export const updateAccordionStatus = (data) => ({
    type: 'ACCORDION_COMPLETED',
    data
});

export const updateRetryCount = (count) => ({
    type: 'UPDATE_RETRY_COUNT',
    data: count
})

export const getcartInfo = (params) => ({
    type: 'GET_CART_INFO',
    params,
});

export const getFloatCart = () => ({
    type: 'GET_FLOAT_CART'
});

export const getCheckoutFloatCart = () => ({
    type: 'CHECKOUT_CART_LOAD'
});

export const getChatInfo = (params) => ({
    type: 'GET_CHAT_INFO',
    params,
})

export const updateCreditCheckInfo = (data) => ({
    type: 'UPDATE_CREDITCHECK_INFO',
    data
})

export const updateOtpStatus = (data) => ({
    type: 'UPDATE_OTP_STATUS',
    data
})

export const postOtp = (data) => ({
    type: 'POST_OTP',
    data
})

export const postValidateOtp = (data) => ({
    type: 'POST_VALIDATE_OTP',
    data
})

export const updatePostOtpResponse = (data) => ({
    type: 'UPDATE_POST_OTP_RESPONSE',
    data
})

export const removePostOtpResponse = (data) => ({
    type: 'REMOVE_POST_OTP_RESPONSE',
    data
})

export const updatePostValidatOtpResponse = (data) => ({
    type: 'UPDATE_POST_VALIDATE_OTP_RESPONSE',
    data
})

export const removePostValidateOtpResponse = (data) => ({
    type: 'REMOVE_POST_VALIDATE_OTP_RESPONSE',
    data
})

export const isOtpVerified = (data) => ({
    type: 'IS_OTP_VERIFIED',
    data
})

export const updateOtpVerifiedMobileNo = (data) => ({
    type: 'UPDATE_OTP_VERIFIED_MOBILE_NO',
    data
})



export const updateCreditCheckStatus = (data) => ({
    type: 'UPDATE_CREDIT_CHECK_STATUS',
    data
})

export const updateAPEnrolledStatus = () => ({
    type: "UPDATE_APENROLLED_STATUS"
});

export const setAPLoading = () => ({
    type: "SET_APLOADING"
});

export const updateAPLoadSuccess = () => ({
    type: "UPDATE_APLOAD_FAILURE"
});

export const resetSubmitOrderInfo = () => ({
    type: "RESET_SUBMITORDER_INFO"
});

export const resetReserveDueDateError = () => ({
    type: "RESET_RESERVE_DUEDATE_ERROR"
});

export const doLOAConfirmation = (data) => ({
    type: "DO_LOA_CONFIRMATION",
    data
});

export const postUIEventLog = (data) => ({
    type: 'POST_EVENT_LOGGING',
    data
});

export const saveCreditCheckState = (data) => ({
    type: 'SAVE_CREDIT_CHECK_STATE',
    data
});

export const resetCheckoutState = (data) => ({
    type: "RESET_CHECKOUT_STATE",
});

export const saveLQEmailAddress = (emailAddress) => ({
    type: 'SAVE_EMAIL_ADDRESS',
    data: emailAddress
});

export const getFCCTemplate = (data) => ({
    type: 'GET_FCC_TEMPLATE',
    data
})
export const storeFCCTemplate = (data) => ({
    type: 'STORE_FCC_TEMPLATE',
    data
})

export const fetchLocusInfo = (data) => ({
    type: 'FETCH_LOCUS_INFO',
    data
})

export const updateTosInfoNor = (data) => ({
    type: "UPDATE_TOS_INFO_NOR",
    data
});

export const resetdateChange = (data) => ({
    type: "IS_RESET_DATE_CHANGE",
    data
});
export const saveIPMResponse = (data) => ({
    type:"SAVE_IPM_RESPONSE",
    data
})
export const updatePaymentMethodType =(data) =>({
    type:"UPDATE_PAYMENT_METHOD_TYPE",
    data
})
export const updateNextButtonCC =(data) =>({
    type:"SAVE_CC_RESPONSE",
    data
})